import $ from 'jquery';
import Axle from 'src/vehicle/chassis/axle';
import Group from 'src/vehicle/chassis/group';
import { parseUnit } from 'src/utils/units_format';

export default class AxlesCanvasOverweights {
  constructor(options = {}) {
    this.groups = [];

    this.axles_group_thresholds = [];
    this.violations             = [];
    this.vehicle                = App.vehicles.filter(vehicle => vehicle.id === options.vehicleId)[0];
    this.numberOfAxles          = this.vehicle.data.numberOfAxles;
    this.spacing                = this.vehicle.data.spacing.map(el => (parseUnit(el) * 12) || 0);
    this.loads                  = this.vehicle.data.loads && this.vehicle.data.loads.map(el => Number(el.replace(/\D+/g, '')));

    $(document).off('click', '[data-behavior~=show-axles-canvas]');

    $(document).on('click', '[data-behavior~=show-axles-canvas]', event => {
      const canvasId  = $(event.target).data('canvas-id');
      const canvasEl  = document.getElementById(canvasId);

      if (!canvasEl) { return; }

      const $tr           = $(canvasEl).closest('tr');
      const $canvasWraper = $(canvasEl).closest('div');

      if ($tr.is(':hidden')) {
        $tr.removeAttr('hidden').show();
        $canvasWraper.removeAttr('hidden').slideDown('slow');
      } else {
        $canvasWraper.slideUp('slow', () => $tr.hide());

        return;
      }

      const state = canvasId;
      const ctx   = canvasEl.getContext('2d');

      ctx.clearRect(0, 0, canvasEl.width, canvasEl.height); // reset canvas

      this.draw(ctx, state);
    });
  }

  draw(ctx, state) {
    this.groups = [];

    this.axles_group_thresholds = App.data.axles_group_thresholds;
    this.violations             = App.data.overweight_violations;

    this.initGroups(state);
    this.render(state);

    if (this.violations && this.violations[state]) {
      ctx.font      = '14px Arial';
      ctx.fillStyle = 'black';
      ctx.textAlign = 'left';

      if (this.grossWeightOver80K()) { // not allowed draw
        ctx.fillText('Max permitted weight', 20, 130);
      } else { // legal draw
        ctx.fillText('Max legal weight', 20, 130);
      }
    }

    this.groups.forEach(group => {
      let violation, violationType;
      if (this.violations && this.violations[state]) {
        violation = this.violations[state][group.description()];

        if (((Number.isFinite(violation.legal.difference) && violation.legal.difference < 0) && !this.grossWeightOver80K()) || ((Number.isFinite(violation.not_allowed.difference) && violation.not_allowed.difference < 0) && this.grossWeightOver80K())) {
          violationType = 'Yes';
        } else {
          violationType = 'No';
        }
      }

      group.draw(ctx, violationType);

      if (this.violations && this.violations[state]) {
        let acc, base_weight;
        ctx.font      = '14px Arial';
        ctx.textAlign = 'center';

        violation = this.violations[state][group.description()];

        let sign  = '';
        let color = 'black';

        if (this.grossWeightOver80K()) { // not allowed draw
          if (Number.isFinite(violation.not_allowed.difference) && violation.not_allowed.difference < 0) {
            sign  = '';
            color = 'red';
          } else if (Number.isFinite(violation.not_allowed.difference) && violation.not_allowed.difference > 0) {
            sign  = '+';
            color = 'green';
          } else {
            sign  = '';
            color = 'black';
          }

          if (this.loads) {
            ctx.font      = '14px Arial';
            ctx.fillStyle = color;
            ctx.textAlign = 'center';

            acc = 0;
            group.axles.forEach(axle => acc += this.loads[axle.number - 1]);

            ctx.fillText(acc.toLocaleString() + ' lbs', group.centerX(), 80);
            ctx.font = '12px Arial';
            ctx.fillText(Number.isFinite(violation.not_allowed.difference) ? sign + violation.not_allowed.difference : 'N/A', group.centerX(), 100);
          }

          ({
            base_weight
          } = violation.not_allowed);
          const not_allowed = base_weight ?
                          base_weight.toLocaleString() + ' lbs'
                        :
                          'N/A';

          ctx.font      = '14px Arial';
          ctx.fillStyle = 'black';
          ctx.fillText(not_allowed, group.centerX(), 130);
        } else { // legal draw
          if (Number.isFinite(violation.legal.difference) && violation.legal.difference < 0) {
            sign  = '';
            color = 'red';
          } else if (Number.isFinite(violation.legal.difference) && violation.legal.difference > 0) {
            sign  = '+';
            color = 'green';
          } else {
            sign  = '';
            color = 'black';
          }

          if (this.loads) {
            ctx.font      = '14px Arial';
            ctx.fillStyle = color;
            ctx.textAlign = 'center';

            acc = 0;
            group.axles.forEach(axle => acc += this.loads[axle.number - 1]);

            ctx.fillText(acc.toLocaleString() + ' lbs', group.centerX(), 80);
            ctx.font = '12px Arial';
            ctx.fillText(Number.isFinite(violation.legal.difference) ? sign + violation.legal.difference : 'N/A', group.centerX(), 100);
          }

          ({
            base_weight
          } = violation.legal);
          const legal       = base_weight ?
                          base_weight.toLocaleString() + ' lbs'
                        :
                          'N/A';

          ctx.font      = '14px Arial';
          ctx.fillStyle = 'black';
          ctx.fillText(legal, group.centerX(), 130);
        }
      }
    });
  }

  grossWeight() {
    return this.vehicle.data.loads.reduce(((acc, currentValue) => acc + Number(currentValue.replace(/\D/g, ''))), 0);
  }

  grossWeightOver80K() {
    return this.grossWeight() > 80000;
  }

  initGroups(state) {
    let threshold;
    let group = new Group;
    group.axles.push(new Axle(1, false));

    this.groups.push(group);

    group = new Group;
    group.axles.push(new Axle(2, false));

    if (this.axles_group_thresholds && state) {
      threshold = this.axles_group_thresholds[state];
    } else {
      threshold = 96;
    }

    for (let number = 3, end = this.numberOfAxles, asc = 3 <= end; asc ? number <= end : number >= end; asc ? number++ : number--) {
      if ((this.spacing[number - 2] > threshold) || this.axleIsAPusher(number) || this.previousAxleIsAPusher(number)) {
        this.groups.push(group);
        group = new Group;
      }

      group.axles.push(new Axle(number, this.axleIsAPusher(number)));
    }

    this.groups.push(group);
  }

  axleIsAPusher(number) {
    if (!this.loads) { return false; }

    return this.loads[number - 1] === 0;
  }

  previousAxleIsAPusher(number) {
    if (!this.loads) { return false; }

    return this.loads[number - 2] === 0;
  }

  render(state) {
    let x;
    if (state) {
      x = 210;
    } else {
      x = 50;
    }

    this.groups.forEach(function(group) {
      group.axles.forEach(function(axle) {
        axle.x = x;
        x += 50;
      });

      x += 50;
    });
  }

  show(state) {
    const $canvasEl = document.getElementById(state);

    if (!$canvasEl) { return; }

    const ctx   = $canvasEl.getContext('2d');

    ctx.clearRect(0, 0, $canvasEl.width, $canvasEl.height); // reset canvas

    this.draw(ctx, state);
  }
};
